import { render, staticRenderFns } from "./TeamFansOverview.vue?vue&type=template&id=56a83a16&scoped=true&"
import script from "./TeamFansOverview.vue?vue&type=script&lang=js&"
export * from "./TeamFansOverview.vue?vue&type=script&lang=js&"
import style0 from "./TeamFansOverview.vue?vue&type=style&index=0&id=56a83a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a83a16",
  null
  
)

export default component.exports